import { i18n } from "@lingui/core";
import { messages as daMessages } from "../../locales/da.mjs";
import { messages as enMessages } from "../../locales/en.mjs";
import { messages as nbMessages } from "../../locales/nb.mjs";
import { messages as svMessages } from "../../locales/sv.mjs";
import { Locale } from "../constants.js";
import { detect, fromHtmlTag } from "@lingui/detect-locale";

export const activateI18n = (loc?: Locale) => {
    const locale = loc || detect(fromHtmlTag("lang"), "en");
    const messageBundle = getMessageBundle(locale);
    i18n.load(locale, messageBundle);
    i18n.activate(locale);
};

const getMessageBundle = (locale: string) => {
    switch (locale) {
        case "da":
            return daMessages;
        case "nb":
            return nbMessages;
        case "sv":
            return svMessages;
        case "en":
        default:
            return enMessages;
    }
};
